var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactionPlatform1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10265_14858)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 7,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9997 14.666C28.4417 14.666 28.8656 14.8416 29.1782 15.1542C29.4907 15.4667 29.6663 15.8907 29.6663 16.3327V24.666H24.2497C23.9182 24.666 23.6002 24.7977 23.3658 25.0321C23.1314 25.2666 22.9997 25.5845 22.9997 25.916V31.3327H17.9997C17.5576 31.3327 17.1337 31.1571 16.8212 30.8445C16.5086 30.532 16.333 30.108 16.333 29.666V16.3327C16.333 15.8907 16.5086 15.4667 16.8212 15.1542C17.1337 14.8416 17.5576 14.666 17.9997 14.666H27.9997ZM21.333 22.166H20.4997C20.2787 22.166 20.0667 22.2538 19.9104 22.4101C19.7541 22.5664 19.6663 22.7783 19.6663 22.9993C19.6663 23.2204 19.7541 23.4323 19.9104 23.5886C20.0667 23.7449 20.2787 23.8327 20.4997 23.8327H21.333C21.554 23.8327 21.766 23.7449 21.9223 23.5886C22.0785 23.4323 22.1663 23.2204 22.1663 22.9993C22.1663 22.7783 22.0785 22.5664 21.9223 22.4101C21.766 22.2538 21.554 22.166 21.333 22.166ZM25.4997 18.8327H20.4997C20.2787 18.8327 20.0667 18.9205 19.9104 19.0768C19.7541 19.233 19.6663 19.445 19.6663 19.666C19.6663 19.887 19.7541 20.099 19.9104 20.2553C20.0667 20.4116 20.2787 20.4993 20.4997 20.4993H25.4997C25.7207 20.4993 25.9326 20.4116 26.0889 20.2553C26.2452 20.099 26.333 19.887 26.333 19.666C26.333 19.445 26.2452 19.233 26.0889 19.0768C25.9326 18.9205 25.7207 18.8327 25.4997 18.8327Z",
    fill: "#013C66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7497 31.3333C25.1388 31.3333 23.833 30.0275 23.833 28.4167C23.833 26.8058 25.1388 25.5 26.7497 25.5C28.3605 25.5 29.6663 26.8058 29.6663 28.4167C29.6663 30.0275 28.3605 31.3333 26.7497 31.3333ZM27.0413 28.4167V26.9583H26.458V29H28.208V28.4167H27.0413Z",
    fill: "#F6948B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10265_14858",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10265_14858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10265_14858",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionPlatform1);
export default __webpack_public_path__ + "static/media/Transaction Platform 1.4b7e8b198fde7e637819504c9173004b.svg";
export { ForwardRef as ReactComponent };